import { useState } from 'react'
import { Outlet } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const EditTrainingIndex = () => {
  const [saved, setSaved] = useState<boolean>(false)
  const [isDirty, setIsDirty] = useState<boolean>(false)
  const [isDisabled, setIsDisabled] = useState<boolean>(false)
  const [courseValidityToggle, setCourseValidityToggle] = useState<boolean>(false)
  return (
    <ResponsivePage.Body variant="fullscreen" showHeader={false}>
      <Outlet
        context={{
          setIsDirty,
          setIsDisabled,
          setSaved,
          saved,
          isDirty,
          isDisabled,
          courseValidityToggle,
          setCourseValidityToggle,
        }}
      />
    </ResponsivePage.Body>
  )
}

export default EditTrainingIndex
